import { Component, input, computed, inject } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { OrderItem } from '../../../../pages/admin-dashboard/orders-management/orders.model';

@Component({
  selector: 'app-view-order-history',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './view-order-history.html',
    styleUrl: './view-order-history.scss',
})
export class ViewOrderHistory {
  private location = inject(Location);
  orderData = input.required<OrderItem>();

  historyEvents = computed(() => {
    const data = this.orderData();

    return [
      {
        statusEn: 'Order Created',
        date: data.createdOn,
        user: data.createdBy?.fullName || 'System',
        description: 'Order initial request submitted.',
        completed: true,
      },
      {
        statusEn: 'Assigned to Employee',
        date: data.request.lastModifiedOn,
        user: data.employee?.fullName || 'Pending Assignment',
        description: data.employee
          ? `Order has been assigned to ${data.employee.fullName}`
          : 'Waiting for employee assignment.',
        completed: !!data.employee, //
      },
      {
        statusEn: data.request.currentStatus.titleEn,
        date: data.request.lastModifiedOn,
        user: data.request.lastModifiedBy?.fullName || 'System',
        description: `Latest update: ${data.request.currentStatus.titleEn}`,
        completed: true,
      },
    ];
  });

  goBack() {
    this.location.back();
  }
}
